import PropTypes from 'prop-types';
import React from 'react';
import Modal from 'shared/components/modal';
import {getMedia} from 'shared/mq';
import Address from './address';

class CannotVerifyAddressModal extends React.Component {
  static propTypes = {
    show: PropTypes.bool.isRequired,
    closeModal: PropTypes.func.isRequired,
    submitForm: PropTypes.func.isRequired,
    originalAddress: PropTypes.object.isRequired,
    onVerifyAddress: PropTypes.func,
    tryAgain: PropTypes.func.isRequired,
  };

  onClick = () => {
    const {submitForm, closeModal, originalAddress, onVerifyAddress} = this.props;

    submitForm(
      {
        ...originalAddress,
        addressVerified: false,
        confirmedUnverifiedAddress: true,
        countyName: '',
        countyFips: '',
      },
      getMedia().MS_AND_DOWN
    );
    if (onVerifyAddress) {
      onVerifyAddress();
    }
    closeModal();
  };

  render() {
    const {show, originalAddress, tryAgain} = this.props;

    return (
      <div>
        <Modal show={show} className="address-verification-modal">
          <Modal.TextHeader onClose={tryAgain}>Double-check your address</Modal.TextHeader>

          <Modal.Body>
            <p>
              There&apos;s a problem with the address provided. Please make sure it&apos;s correct
              before saving.
            </p>
            <Address type="Original" address={originalAddress} />
            <hr aria-hidden="true" />
            <h5 className="address-type">Suggested Address</h5>
            <p className="address-verification-modal-cannot-verify-address-text">
              We couldn&apos;t verify your address. Please try again.
            </p>
          </Modal.Body>

          <Modal.Footer
            primaryButton={{
              text: 'Try Again',
              onClick: tryAgain,
            }}
            secondaryButton={{
              text: 'Confirm Original Address',
              onClick: this.onClick,
              rightAligned: true,
            }}
          />
        </Modal>
      </div>
    );
  }
}

export default CannotVerifyAddressModal;
